import {
  MsRegistrationFormReducer,
  MsRegistrationFormState,
} from './ms-registration-form.reducer';
import { createFeatureSelector } from '@ngrx/store';

export const featureMsRegistrationFormName = 'MsRegistrationForm';

export interface MsRegistrationState {
  msRegistrationForm: MsRegistrationFormState;
}

export const moduleMsRegistrationReducers = {
  msRegistrationForm: MsRegistrationFormReducer,
};

export const getMsRegistrationState =
  createFeatureSelector<MsRegistrationState>(featureMsRegistrationFormName);
